module.exports = __webpack_public_path__ + "static/media/puzzle-piece.3df8347c.svg";